import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { NumberTuner } from '../NumberTuner';

export class NumberTuneCommand implements ICommand {
  private readonly _tuner: NumberTuner;

  private readonly _descriptor: string;

  private readonly _val: number;

  private _prevVal: number;

  public constructor(tuner: NumberTuner, descriptor: string, val: number, prevVal: number) {
    this._tuner = tuner;
    this._descriptor = descriptor;
    this._val = val;
    this._prevVal = prevVal;
  }

  public async execute(): Promise<boolean> {
    await this._tuner.setValueAsync(this._descriptor, this._val);
    return true;
  }

  public async undo(): Promise<boolean> {
    await this._tuner.setValueAsync(this._descriptor, this._prevVal);
    return false;
  }
}
